import React from 'react';
import InventoryProcessTable from '../../components/transaction/InventoryProcessTable';
import { Container, Typography, Paper, Box, Button } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';

const InventoryProcessListPage = () => {
    const navigate = useNavigate();
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Button
          component={Link}
          to="/activity-log"
          variant="contained"
          color="primary"
        >
          View Activity Log
        </Button>
      </Box>
      <Container component="main" maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
              Inventory Process List
            </Typography>
            <Button variant="contained" onClick={() => navigate('/transaction/inventory-process')}>
              Add New Process
            </Button>
          </Box>
          <InventoryProcessTable />
        </Paper>
      </Container>
    </>
  );
};

export default InventoryProcessListPage; 